// extracted by mini-css-extract-plugin
export default {"privacy":"payxPrivacyRemove_privacy__UtDiM","privacy_subtitles":"payxPrivacyRemove_privacy_subtitles__a4JvB"};